'use strict';

/**
 * @author Maxim Seredkin
 */

export default function okvedTree() {
    return {
        restrict: 'A',
        template: require('../view/okved-tree.html'),
        scope: {
            selectedItem: '=myModel',
            selectedOkveds: '=myOkveds',
        },
        controller: ['$scope', 'OkvedService',
                     function($scope, OkvedService) {
                         $scope.search = search;
                         $scope.select = select;
                         $scope.isSelect = isSelect;
                         $scope.isContainSelect = isContainSelect;
                         $scope.pushOkved = pushOkved;
                         $scope.isMulti = Array.isArray($scope.selectedOkveds);
                         $scope.resetAll = function () {
                             $scope.selectedOkveds = [];
                         }

                         init();

                        function pushOkved(okved, $event) {
                            $event.stopPropagation();
                            const findIndex = $scope.selectedOkveds.findIndex(n => n.id === okved.id);
                            if (findIndex === -1) {
                                $scope.selectedOkveds.push(okved);
                                if (okved) {
                                    OkvedService.api.childs({okvedId: okved.id}, (data) => {
                                        $scope.selectedOkveds = $scope.selectedOkveds.concat(data._embedded);
                                    });
                                }
                            } else {
                                $scope.selectedOkveds.splice(findIndex, 1);
                                if (okved) {
                                    OkvedService.api.childs({okvedId: okved.id}, (data) => {
                                        $scope.selectedOkveds = $scope.selectedOkveds.filter(item => !data._embedded.some(n => n.id === item.id))
                                    });
                                }
                            }
                        }
                         // region Function

                         function init() {
                             $scope.loading = true;
                             $scope.isOpen = false;

                             $scope.filter = {};

                             $scope.columns = [{
                                 data: 'code',
                             }, {
                                 data: 'name',
                             }];

                             OkvedService.api.root(null, (data) => {
                                 $scope.items = data._embedded;
                                 if ($scope.selectedItem != null) {
                                     OkvedService.api.path({okvedId: $scope.selectedItem.id}, (data) => update($scope.selectedItem, $scope.items, data._embedded));
                                 }
                                 $scope.loading = false;
                             });
                         }

                         function select(item, isSelected) {
                             if (isSelected) {
                                 $scope.selectedItem = null;
                                 item.nodes = null;
                                 return
                             }
                             $scope.selectedItem = item;
                             if (!item.nodes) {
                                 OkvedService.api.childs({okvedId: item.id}, (data) => item.nodes = data._embedded);
                             }
                         }

                         function isSelect(item) {
                             return $scope.selectedItem === item;
                         }

                         function isContainSelect(item) {
                             return $scope.selectedOkveds.some(n => n.id === item.id)
                         }

                         function update(selectedItem, items, path) {
                             let item = items.find((i) => i.id == path[0].id);
                             if (!item.nodes) {
                                 OkvedService.api.childs({okvedId: item.id}, (data) => {
                                     item.nodes = data._embedded;
                                     path.splice(0, 1);
                                     if (path.length > 0) {
                                         update(selectedItem, item.nodes, path);
                                     } else {
                                         $scope.select(item);
                                         $scope.$applyAsync(function() {
                                             $scope.$broadcast('updateStateNode', null);
                                         });
                                     }
                                 });
                             } else {
                                 path.splice(0, 1);
                                 if (path.length > 0) {
                                     update(selectedItem, item.nodes, path);
                                 } else {
                                     $scope.select(item);
                                     $scope.$applyAsync(function() {
                                         $scope.$broadcast('updateStateNode', null);
                                     });
                                 }
                             }
                         }

                         function search() {
                             if ($scope.filter.codeOkved != null && $scope.filter.codeOkved.length != 0) {
                                 OkvedService.api.get({
                                                          filters: [`'code' EQ '${$scope.filter.codeOkved}'`,
                                                                    `'status' EQ 'ENABLED'`],
                                                      }, (data) => {
                                     if (data._embedded != null && Array.isArray(data._embedded) && data._embedded.length > 0) {
                                         $scope.selectedItem = data._embedded[0];
                                     } else {
                                         $scope.selectedItem = null;
                                     }
                                 });
                             } else {
                                 $scope.selectedItem = null;
                             }
                         }

                         // endregion

                         // region Watcher

                         $scope.$watch('selectedItem', function() {
                             if ($scope.selectedItem != null) {
                                 $scope.filter.codeOkved = $scope.selectedItem.code;
                                 OkvedService.api.path({okvedId: $scope.selectedItem.id}, (data) => update($scope.selectedItem, $scope.items, data._embedded));
                             }
                         });

                         // endregion
                     }],
    };
}